import { jsx as _jsx } from "react/jsx-runtime";
import { PageBody } from '../../../../components/layout';
import { useProgramContext } from '../../../../layouts/ProgramLayout';
import { PeriodsOfPerformanceTab } from '../tabs/PeriodsOfPerformanceTab';
export function PeriodsPage() {
    const { programId } = useProgramContext();
    return /*#__PURE__*/ _jsx(PageBody, {
        children: /*#__PURE__*/ _jsx(PeriodsOfPerformanceTab, {
            programId: programId
        })
    });
}
